import { render } from "./component-rezident-rf.vue?vue&type=template&id=344a06b4"
import script from "./component-rezident-rf.vue?vue&type=script&setup=true&lang=js"
export * from "./component-rezident-rf.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/counteragents/counteragent-version-card/components/component-rezident-rf.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "344a06b4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('344a06b4', __exports__)) {
    api.reload('344a06b4', __exports__)
  }
  
  module.hot.accept("./component-rezident-rf.vue?vue&type=template&id=344a06b4", () => {
    api.rerender('344a06b4', render)
  })

}


export default __exports__